import { lazy } from "react";
import othersRoute from "./othersRoute";
import type { Routes } from "@/@types/routes";
import { uiPaths } from "@/custolink-transpiled_by_server/ui_paths";

export const nonProtectedAdminRoutes: Routes = [
  {
    key: "signIn",
    path: `/admin/sign-in`,
    component: lazy(() => import("@/custolink-views/admin/auth/SignIn")),
    componentNewDesign: lazy(() => import("@/custolink-newdesign/pages/SignIn")),
    authority: [],
  },
  {
    key: "forgotPassword",
    path: `/admin/forgot-password`,
    component: lazy(() => import("@/custolink-views/admin/auth/ForgotPassword")),
    componentNewDesign: lazy(() => import("@/custolink-newdesign/pages/ForgotPassword")),
    authority: [],
  },
  {
    key: 'resetPassword',
    path: uiPaths.resetPasswordUserPathPrefix + "/:token",
    component: lazy(() => import("@/custolink-views/admin/auth/ResetPasswordForUser")),
    componentNewDesign: lazy(() => import("@/custolink-newdesign/pages/ResetPasswordForUser")),
    authority: [],
  },
  {
    key: 'verifyEmail',
    path: uiPaths.verifyEmailUserPathPrefix + "/:token",
    component: lazy(() => import("@/custolink-views/admin/auth/VerifyEmailForUser")),
    componentNewDesign: lazy(() => import("@/custolink-newdesign/pages/VerifyEmailForUser")),
    authority: [],
  },

  /*{
      key: 'signUp',
      path: `/sign-up`,
      component: lazy(() => import('@/views/auth/SignUp')),
      authority: [],
  },

  {
      key: 'resetPassword',
      path: `/reset-password`,
      component: lazy(() => import('@/views/auth/ResetPassword')),
      authority: [],
  },*/
];

export const protectedRoutes: Routes = [
  {
    key: "home",
    path: "/home",
    component: lazy(() => import("@/custolink-views/admin/home/Home")),
    componentNewDesign: lazy(() => import("@/custolink-newdesign/pages/Home")),
    authority: ["ROLE_ADMINAREA_USER"],
  },

  {
    key: "home",
    path: "/profile",
    component: lazy(() => import("@/custolink-views/admin/profile/Profile")),
    componentNewDesign: lazy(() => import("@/custolink-newdesign/pages/Profile")),
    authority: ["ROLE_ADMINAREA_USER"],
    meta: {
      header: {
        title: "Profile",
      },
      pageContainerType: "contained",
    },
  },

  {
    key: "assets.list",
    path: "/assets",
    component: lazy(() => import("@/custolink-views/admin/assets/AssetsList")),
    componentNewDesign: lazy(() => import("@/custolink-newdesign/pages/Assets")),
    authority: ["ROLE_ADMINAREA_USER"],

    meta: {
      header: {
        title: "Assets",
        contained: true,
      },
      footer: false,
    },
  },
  {
    key: "assets.import",
    path: "/assets/import",
    component: lazy(
      () => import("@/custolink-views/admin/assets/AssetsImportHistory"),
    ),
    componentNewDesign: lazy(
      () => import("@/custolink-newdesign/pages/ImportHistory"),
    ),
    authority: ["ROLE_ADMINAREA_USER"],
  },
  {
    key: "filemanager2",
    path: "/filemanager2",
    component: lazy(
      () => import("@/custolink-views/admin/filemanager2/FileManager"),
    ),
    componentNewDesign: lazy(
      () => import("@/custolink-newdesign/pages/FileManager"),
    ),
    authority: ["ROLE_ADMINAREA_USER"],

    meta: {
      header: {
        title: "",
        contained: true,
      },
      footer: false,
    },
  },
  {
    key: "communication.end_users",
    path: "/communication/customers",
    component: lazy(
      () => import("@/custolink-views/admin/communication/customers/Customers"),
    ),
    componentNewDesign: lazy(
      () => import("@/custolink-newdesign/pages/Customers"),
    ),
    authority: ["ROLE_ADMINAREA_USER"],
  },
  {
    key: "communication.support",
    path: "/communication/support",
    component: lazy(
      () => import("@/custolink-views/admin/communication/support_hub/Support"),
    ),
    componentNewDesign: lazy(
      () => import("@/custolink-newdesign/pages/Support"),
    ),
    authority: ["ROLE_ADMINAREA_USER"],
  },
  {
    key: "communication.support.review",
    path: "/communication/support/review/:callId",
    component: lazy(
      () => import("@/custolink-newdesign/pages/support/review/SessionReviewPage"),
    ),
    componentNewDesign: lazy(
      () => import("@/custolink-newdesign/pages/support/review/SessionReviewPage"),
    ),
    authority: ["ROLE_ADMINAREA_USER"],
  },
  {
    key: "settings.assets",
    path: "/settings/assets",
    component: lazy(
      () =>
        import("@/custolink-views/admin/settings/assets/AssetFrontendSettings"),
    ),
    componentNewDesign: lazy(
      () => import("@/custolink-newdesign/pages/SettingsAssetFrontend"),
    ),
    authority: ["ROLE_ADMINAREA_USER"],
  },
  {
    key: "settings.web.inte",
    path: "/settings/web_inte",
    component: lazy(
      () =>
        import(
          "@/custolink-views/admin/settings/web_integration/WebIntegration"
        ),
    ),
    componentNewDesign: lazy(
      () => import("@/custolink-newdesign/pages/WebIntegrations"),
    ),
    authority: ["ROLE_ADMINAREA_USER"],
    meta: {
      header: {
        title: "Settings › Web Integration",
        contained: true,
      },
      footer: false
    },
  },
  {
    key: "settings.web.inte.configure",
    path: "/settings/web_inte/:integrationId",
    component: lazy(
      () =>
        import(
          "@/custolink-views/admin/settings/web_integration/ConfigureIntegration"
        ),
    ),
    componentNewDesign: lazy(
      () => import("@/custolink-newdesign/pages/WebIntegrationDetail"),
    ),
    authority: ["ROLE_ADMINAREA_USER"],
    meta: {
      header: {
        title: "Settings › Web Integration › Configure",
        contained: true,
      },
      footer: false
    },
  },
  {
    key: "settings.users",
    path: "/settings/users",
    component: lazy(
      () =>
        import(
          "@/custolink-views/admin/settings/user_management/UserManagement"
        ),
    ),
    componentNewDesign: lazy(
      () => import("@/custolink-newdesign/pages/UserManagement"),
    ),
    authority: ["ROLE_ADMINAREA_USER"],
  },
  {
    key: "settings.look_and_feel",
    path: "/settings/look_and_feel",
    component: lazy(
      () =>
        import("@/custolink-views/admin/settings/look_and_feel/LookAndFeel"),
    ),
    componentNewDesign: lazy(
      () => import("@/custolink-newdesign/pages/LookAndFeel"),
    ),
    authority: ["ROLE_ADMINAREA_USER"],
    meta: {
      header: {
        title: "Look And Feel",
      },
      pageContainerType: "contained",
    },
  },

  {
    key: "cp_home",
    path: "/_cp/home",
    component: lazy(() => import("@/custolink-views/controlpanel/CpHome")),
    componentNewDesign: lazy(
      () => import("@/custolink-newdesign/pages/controlpanel/CpHome"),
    ),
    authority: ["ROLE_CP_ADMIN"],
  },
  {
    key: "cp.translations",
    path: "/_cp/translations",
    component: lazy(
      () => import("@/custolink-views/controlpanel/CpTranslations"),
    ),
    componentNewDesign: lazy(
      () => import("@/custolink-newdesign/pages/controlpanel/CpTranslations"),
    ),
    authority: ["ROLE_CP_ADMIN"],
    meta: {
      header: {
        title: "Translation",
      },
      pageContainerType: "contained",
    },
  },
  {
    key: "cp.cstln_data",
    path: "/_cp/cstln_data",
    component: lazy(() => import("@/custolink-views/controlpanel/CpCstlnData")),
    componentNewDesign: lazy(
      () => import("@/custolink-newdesign/pages/controlpanel/CpCstlnData"),
    ),
    authority: ["ROLE_CP_ADMIN"],
    meta: {
      header: {
        title: "CSTLN DATA",
      },
      pageContainerType: "contained",
    },
  },

  ...othersRoute,
];
